import React from 'react';
import { Link } from 'react-router-dom';
import PodiumPickerIcon from './PodiumPickerIcon';
import './Footer.css';

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-columns">
        <div className="footer-column">
          <div className="footer-brand">
            <PodiumPickerIcon size={32} />
            <h3>Podium Picker</h3>
          </div>
          <p>A fan-made F1 podium prediction game.</p>
        </div>
        <div className="footer-column">
          <h3>Quick Links</h3>
          <ul>
            <li><Link to="/dashboard">Dashboard</Link></li>
            <li><Link to="/history">History</Link></li>
          </ul>
        </div>
        <div className="footer-column">
          <h3>About</h3>
          <p>Made by fans, for fans.</p>
        </div>
      </div>
      <div className="footer-bottom">
        <p>© {new Date().getFullYear()} Podium Picker</p>
        <p>
          This is an unofficial fan site and is not affiliated with, endorsed by, or connected to
          Formula 1, Formula One Management Ltd (FOM), the FIA, or any Formula 1 team. Formula 1,
          F1, and related marks are trademarks of Formula One Licensing B.V.
        </p>
      </div>
    </footer>
  );
}

export default Footer;
